export default __webpack_public_path__ + "static/media/lb-ag.72127e2d.webp";